import * as VOXLib from 'voximplant-websdk';
import type { SharingCall } from 'voximplant-websdk/Call/SharingCall';

/** Установить слушатель события демонстрации экрана */
export function attachVOXSharingCallEvents(sharingCall: SharingCall, setControls: (result: boolean) => void) {
    function handleConnected() {
        setControls(true);
    }

    function handleDisconnected() {
        setControls(false);
    }

    return {
        off: () => {
            sharingCall.off(VOXLib.CallEvents.Connected, handleConnected);
            sharingCall.off(VOXLib.CallEvents.Disconnected, handleDisconnected);
        },
        on: () => {
            sharingCall.on(VOXLib.CallEvents.Disconnected, handleDisconnected);
            sharingCall.on(VOXLib.CallEvents.Connected, handleConnected);
        },
    };
}
